// Toutes les informations ci-dessous sont issues du site source chauffeplus19.fr
// (pages Accueil, Ramonage, Sanitaires, Contact) et n'ont pas été inventées.

export const company = {
  name: 'Chauffe Plus 19',
  owner: 'Julien Nésius',
  tagline:
    'Chauffage, ramonage, débistrage, climatisation et plomberie en Corrèze',
  intro:
    "Installation, entretien et dépannage de vos équipements de chauffage, climatisation et plomberie. Un service de proximité pour un confort durable toute l'année.",
  about:
    "Installé à Lostanges, Julien Nésius intervient sur l'ensemble de la Corrèze, notamment à Meyssac, Collonges-la-Rouge, Branceilles, Nonards, Beaulieu-sur-Dordogne, Brive-la-Gaillarde et Tulle. Chauffe Plus 19 est à votre écoute et vous oriente vers les solutions les plus adaptées.",
  ramoneurNote:
    "Julien Nésius est titulaire du titre de Ramoneur-Fumiste. Ce diplôme l'autorise à réaliser les ramonages, débistrage, tubage et pose de poêle, en vous assurant la réalisation d'un travail en conformité avec la réglementation.",
  devisNote: 'Chauffe Plus 19 : devis sur demande',
  phone: '06 20 87 16 61',
  phoneHref: 'tel:+33620871661',
  email: 'chauffeplus19@gmail.com',
  emailHref: 'mailto:chauffeplus19@gmail.com',
  addressLines: ['La Boureyrie', '1082, Route de la Sourdoire', '19500 Lostanges'],
  website: 'www.chauffeplus19.fr',
} as const

export const domains = [
  'Chauffage',
  'Ramonage',
  'Débistrage',
  'Climatisation',
  'Plomberie',
  'Ventilation',
] as const

export const qualifications = [
  {
    title: 'Maintenance en équipement thermique individuel (METI)',
    detail: null,
  },
  {
    title: 'Ramoneur-Fumiste diplômé du COSTIC',
    detail:
      'Exigé par les assurances en cas de sinistre, selon la loi 96-603 Raffarin du 5 juillet 1996.',
  },
  {
    title: 'Professionnel du gaz',
    detail: 'Habilitation pour souder et intervenir sur les réseaux de gaz.',
  },
  { title: 'Installateur électrique en bâtiment', detail: null },
  { title: 'Installateur sanitaire', detail: null },
] as const

export const decennale = 'Garantie décennale pour toutes ces prestations.'

export const zones = [
  'Lostanges',
  'Meyssac',
  'Collonges-la-Rouge',
  'Branceilles',
  'Nonards',
  'Beaulieu-sur-Dordogne',
  'Brive-la-Gaillarde',
  'Tulle',
] as const

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/b0786c03-fd9a-4a22-88a3-1747abde5040.jpg',
  ramonage:
    'https://cdn.magicpatterns.com/patterns/generated-images/9ddcee9c-e45d-4d3e-beda-092a2d648e95.jpg',
  plomberie:
    'https://cdn.magicpatterns.com/patterns/generated-images/0834d4b6-aae5-4e4d-89d3-56d1fde6074c.jpg',
  climatisation:
    'https://cdn.magicpatterns.com/patterns/generated-images/e3f3c00e-3d7a-4152-88ac-7044e4999f87.jpg',
} as const

export type ServiceKey = 'chauffage' | 'ramonage' | 'plomberie'

export type Service = {
  key: ServiceKey
  path: string
  label: string
  shortLabel: string
  summary: string
  bullets: string[]
  image: string
  imageAlt: string
}

export const services: Service[] = [
  {
    key: 'chauffage',
    path: '/chauffage',
    label: 'Chauffage & climatisation',
    shortLabel: 'Chauffage',
    summary:
      "Installation, entretien et dépannage de vos équipements de chauffage et de climatisation, quelle que soit l'énergie.",
    bullets: [
      'Installation de systèmes de chauffage (gaz, fioul, bois, granulés)',
      'Entretien et dépannage de chaudières, inserts et poêles',
      'Climatisation et ventilation : installation, entretien, dépannage',
      'Tubage et chemisage de conduits de fumée',
      "Diagnostic, mise en conformité et remise aux normes d'installations de chauffage",
    ],
    image: images.climatisation,
    imageAlt:
      "Installation d'une unité de climatisation murale dans une pièce claire",
  },
  {
    key: 'ramonage',
    path: '/ramonage-debistrage',
    label: 'Ramonage & débistrage',
    shortLabel: 'Ramonage',
    summary:
      'Ramonage de tous conduits et débistrage réalisés par un Ramoneur-Fumiste diplômé, en conformité avec la réglementation.',
    bullets: [
      'Ramonage et entretien de chaudière gaz, fioul, bois, granulés, insert, poêle à bois, biomasse',
      'Ramonage tous conduits, chaudières tous combustibles (poêle, insert, cuisinière, granulés)',
      'Débistrage tous conduits, même industriels',
      'Le débistrage est obligatoire avant tout tubage ou gainage dans un conduit de fumée, imposé par les assurances',
    ],
    image: images.ramonage,
    imageAlt: "Ramonage d'un conduit de cheminée sur le toit d'une maison en pierre",
  },
  {
    key: 'plomberie',
    path: '/plomberie-sanitaires',
    label: 'Plomberie & sanitaires',
    shortLabel: 'Plomberie',
    summary:
      "Travaux de plomberie et aménagement de sanitaires, de la salle de bains clés en main au réseau d'alimentation.",
    bullets: [
      'Aménagement de salle de bains clés en main',
      'WC',
      'Salle de bains pour personne à mobilité réduite',
      "Réseau d'alimentation",
    ],
    image: images.plomberie,
    imageAlt: 'Salle de bains moderne avec douche à l’italienne et meuble en chêne',
  },
]
